export default __webpack_public_path__ + "static/media/truck.7b43dc77.svg";